import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import { ApplicantLayout } from '@platform-ui/application/components/index.js';
import useApplicationConfig from '@platform-ui/application/hooks/useApplicationConfig.js';
import { SectionsOverview } from '@platform-ui/application/pages/index.js';
import ApplicantRoutes from '@platform-ui/application/utils/ApplicantRoutes.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import { canAccessProgram } from '@platform-ui/utilities/programs.js';
import { Redirect, Route, Switch } from 'react-router';
import { Navigate } from 'react-router-dom-v5-compat';
import IntroScreen from './pages/IntroScreen/index.js';

export default function IntroRoutes(): JSX.Element {
  const program = useProgram();
  const { introPages } = useApplicationConfig();
  const { user } = useAuth();

  if (!canAccessProgram(program, user.core))
    return <Navigate to={ApplicantRoutes.APPLICATION_PORTAL} />;

  return (
    <ApplicantLayout>
      <Switch>
        <Route path={ApplicantRoutes.SECTIONS_OVERVIEW} component={SectionsOverview} />
        <Route path={ApplicantRoutes.INTRO_PAGE} component={IntroScreen} />
        <Redirect
          to={makeRoute(
            introPages.length ? ApplicantRoutes.INTRO_PAGE : ApplicantRoutes.SECTIONS_OVERVIEW,
            { programId: program.id, screenKey: introPages[0]?.key },
          )}
        />
      </Switch>
    </ApplicantLayout>
  );
}
